import { combineReducers } from 'redux';

import landingPageReducer from '../LandingPage/reducer'

const rootReducer = combineReducers({
    landingPage: landingPageReducer
})

export default rootReducer
